import React, { useContext, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { RecruitmentContext } from "../../../../context/states/recruitmentState";

import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardContent,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Chip,
  Avatar,
  CircularProgress,
  Grid,
} from "@material-ui/core";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import EditRecruitmentForm from "./EditForm/EditRecruitmentForm";
import { AuthContext } from "../../../../context/states/authState";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0),
    padding: theme.spacing(2, 0),
  },
  appBar: {
    marginBottom: "14px",
  },
  title: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2, 1.5),
    margin: theme.spacing(1, 0),
  },
}));

const EditRecruitment = () => {
  const classes = useStyles();
  const { id } = useParams();
  const history = useHistory();

  const {
    getRecruitmentHandler,
    updateRecruitmentHandler,
    updateRecruitmentNotesHandler,
    recruitment,
    load,
    error,
  } = useContext(RecruitmentContext);

  const { currentUser } = useContext(AuthContext);
  const { role, fullName } = currentUser;

  const isAccessTo = role === "admin" ? true : false;

  async function fetchData() {
    await getRecruitmentHandler(id);
  }

  console.log(recruitment);

  useEffect(() => {
    let unmounted = true;

    if (unmounted) {
      fetchData();
    }

    return () => (unmounted = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const goBack = () => {
    history.push({
      pathname: "/RecruitmentTracker",
      state: { page: "recruitment" },
    });
  };

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <div className={classes.root}>
          <AppBar
            position="sticky"
            color="default"
            style={{ top: "3.6em" }}
            elevation={2}
          >
            <Toolbar variant="dense">
              <IconButton
                aria-label="Back to list"
                onClick={goBack}
                color="inherit"
                edge="start"
              >
                <ArrowBackIcon />
              </IconButton>

              <Typography variant="h6" className={classes.title}>
                {!load ? (
                  <>
                    {recruitment?.name}{" "}
                    <Chip
                      avatar={<Avatar>R</Avatar>}
                      label={recruitment?.recId}
                      clickable
                      color="primary"
                      size="small"
                    />
                  </>
                ) : (
                  <small>Loading...</small>
                )}
              </Typography>
            </Toolbar>
          </AppBar>

          <Card className={classes.root}>
            <CardContent>
              {error ? (
                <Typography variant="h6">{error}</Typography>
              ) : (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  {load ? (
                    <Grid
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                    >
                      <Grid item xs={12}>
                        <CircularProgress style={{ margin: "12rem" }} />
                      </Grid>
                    </Grid>
                  ) : (
                    <EditRecruitmentForm
                      recruitment={recruitment}
                      classes={classes}
                      handleUpdate={updateRecruitmentHandler}
                      handleHistory={history}
                      handleBack={goBack}
                      isAccessTo={isAccessTo}
                      username={fullName}
                      role={role}
                      updateRecruitmentNotesHandler={
                        updateRecruitmentNotesHandler
                      }
                    />
                  )}
                </MuiPickersUtilsProvider>
              )}
            </CardContent>
          </Card>
        </div>
      </Grid>
    </React.Fragment>
  );
};

export default EditRecruitment;
